.vt-loading-ring {
  display: inline-block;
  border-radius: 50%;
  border-style: solid;
  animation: vt-loading-spin 0.8s linear infinite;
}

@keyframes vt-loading-spin {
  to {
    transform: rotate(360deg);
  }
}

.vt-loading-overlay-wrap {
  position: relative;
  display: inline-block;
}

.vt-loading-overlay-content {
  filter: blur(1.5px);
  opacity: 0.5;
  pointer-events: none;
}

.vt-loading-overlay-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
